"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.directMessages.loadFailed': 'Failed to load direct messages.',
    'whatsapp.directMessages.search': 'Search contacts...',
    'whatsapp.directMessages.contacts': 'Contacts',
    'whatsapp.directMessages.noContacts': 'No direct message contacts found.',
    'whatsapp.directMessages.trackLogs': 'Track Logs',
    'whatsapp.directMessages.selectContact': 'Select a contact to view track logs.',
    'whatsapp.directMessages.noLogs': 'No track logs for this contact.',
    'whatsapp.directMessages.viewDetails': 'View Details',
};
